export default {
  title: "Items",
  item_overview: "Item Overview",
  table_column_designation_label: "Designation",
  table_column_item_id_label: "Item ID",
  table_column_location_id_label: "Location ID",
  table_column_item_class_label: "Item Class",
  table_column_model_label: "Model",
  table_column_location_label: "Location access",
  table_column_layout_label: "Layout",
  tab_overview: "Overview",
  tab_item_data: "Item data",
  tab_model_data: "Model data",
  tab_attached: "Attached",
  tab_related_items: "Related Items",
  item: "Item",
  tab_issues: "Issues",
  tab_issues_with_count: "Issues ({count} Open)",
  tab_work_orders: "Work Orders",
  tab_work_orders_with_count: "Work Orders ({count} Open)",
  item_class_label: "Item Class",
  item_id_label: "Item ID",
  designation_label: "Designation",
  item_designation_label: "Item Designation",
  most_recent_issue_label: "Most recent Issue",
  issues_meantime: "Mean time between Issues",
  next_issue: "Predicted next Issue",
  most_recent_work_label: "Most recent Performed Work",
  work_meantime: "Mean time between Work",
  previous_work: "Previous Work",
  missing_data: "Not enough data yet...",
  workspace_name: "Workspace Name",
  title_configure_issues_n_work: "Configure Issues and Work Orders",
  title_issues_n_work: "Issues and Work",
  tab_data_id: "ID",
  tab_data_designation: "Designation",
  tab_data_item_class: "Item Class",
  tab_data_location: "Location",
  tab_data_model: "Model",
  tab_data_update_item: "Item successfully updated",
  tab_data_error_value_unique: "Value must be unique",
  tab_data_error_form: "Some of the fields above have errors. Please fix them in order to submit",
  breadcrumb_create_item: "Create Item",
  breadcrumb_clone_item: "Clone Item",
  error_value_unique: "Value must be unique",
  item_created: "Item successfully created",
  error_attributes:
    "There was an error trying to create attributes. Please update them in the items overview page.",
}
